import { stringifyGraph } from '@/clients/http'
import { StockModel } from '@/http/models/Stock/Stock'
import { toast } from 'sonner'

import { useState } from 'react'

import { StockTransactionModel } from '@/types'

import { useFetchStockHistory } from './useFetchStockHistory'

interface Options {
  onPurchaseSuccess?: () => void
}

export const useStockTable = ({ onPurchaseSuccess }: Options = {}) => {
  const [purchaseDialogOpen, setPurchaseDialogOpen] = useState(false)
  const [detailDialogOpen, setDetailDialogOpen] = useState(false)

  const [detailData, setDetailData] = useState<StockTransactionModel.StockTransaction | null>(null)
  const [detailLoading, setDetailLoading] = useState(false)
  const [purchaseLoading, setPurchaseLoading] = useState(false)

  const { loading, data, pagination, formValues, formMethods, setPage, setPageSize, refresh } =
    useFetchStockHistory({})

  const handleViewDetail = async (tx: StockTransactionModel.StockTransaction) => {
    setDetailData(null)
    setDetailDialogOpen(true)
    setDetailLoading(true)

    const res = await StockModel.getById({
      params: { id: tx._id },
      query: {
        graph_enc: stringifyGraph({
          '*': true,
          items: {
            '*': true,
            productVariation: {
              '*': true,
              product: { '*': true },
            },
          },
        }),
      },
    })

    if (res.success) {
      setDetailData(res.data?.result ?? null)
    } else {
      toast.error('Failed to load transaction details')
      setDetailDialogOpen(false)
    }

    setDetailLoading(false)
  }

  const handleCreatePurchase = async (body: any) => {
    setPurchaseLoading(true)

    const res = await StockModel.purchase({ body })

    if (res.success) {
      toast.success('Purchase recorded successfully')
      setPurchaseDialogOpen(false)
      refresh()
      onPurchaseSuccess?.()
    } else {
      toast.error((res.error?.data as any)?.message || 'Failed to record purchase')
    }

    setPurchaseLoading(false)
  }

  return {
    loading,
    data,
    pagination,
    formValues,
    formMethods,
    setPage,
    setPageSize,
    refresh,
    detailDialogOpen,
    setDetailDialogOpen,
    detailData,
    detailLoading,
    handleViewDetail,
    purchaseDialogOpen,
    setPurchaseDialogOpen,
    purchaseLoading,
    handleCreatePurchase,
  }
}
